import config from '../../../../config/config';
import { Configuration, TranslationsModuleApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const translateApi = new TranslationsModuleApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
